module.exports = __webpack_public_path__ + "img/viewed.320fe8b0.svg";